import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { cronJobs, restartJob, singleCronJob } from '../mockData/cron-job-data';

const CronJobApi = [
  rest.get(`${API_ROOT}cron-jobs`, (req, res, ctx) => res(ctx.json(cronJobs))),
  rest.get(`${API_ROOT}cron-jobs/FoodReminder`, (req, res, ctx) => res(ctx.json(singleCronJob))),
  rest.post(`${API_ROOT}cron-jobs`, (req, res, ctx) => res(ctx.json(restartJob))),
];
export default CronJobApi;
